import gql from 'graphql-tag';

export const DetailsPanelContentViewsQuery = gql`
	query DetailsPanelContentViewsQuery($contentId: ID!, $isDraft: Boolean!) {
		contentAnalyticsViewers(contentId: $contentId) @skip(if: $isDraft) {
			count
		}
	}
`;
